import { PermissionCategory } from '../models/permission-category.model';
import { Role } from '../models/role.model';

export class PermissionCategoryModalData {
  permissionCategory: PermissionCategory;
  roles: Array<Role>;
  withForm?: boolean;
  withRoles?: boolean;
}
